import {
  ENTITY_NAVIGATION_CLEAR,
  ENTITY_NAVIGATION_FETCH_START,
  ENTITY_NAVIGATION_FETCH_SUCCESS
} from '@constants/action-types';
import initialState from '../store/initial-state';

const entityNavigationReducer = (state = initialState.entityNavigation, action) => {
  switch (action.type) {
  case ENTITY_NAVIGATION_FETCH_START:
    return { ...state, loading: true };
  case ENTITY_NAVIGATION_FETCH_SUCCESS:
    return {
      ...state,
      rows: action.payload.rows,
      count: action.payload.count,
      offset: action.payload.offset,
      limit: action.payload.limit,
      loading: false
    };
  case ENTITY_NAVIGATION_CLEAR:
    return { ...initialState.entityNavigation };
  default:
    return state;
  }
};

export default entityNavigationReducer;
